<template>
    <div class="row">
        <div class="col">
            <div v-if="trades.length">
                <p class="h3 text-center"><strong>Select your trade:</strong></p>
                <div class="trades">
                    <slick ref="slickTrades" class="slickTrades"
                           :options="slickTradesOptions"
                           :data-selected="selectedTrade"
                           @breakpoint="slickHandleBreakpoint">
                        <div v-for="(trade, index) in trades" :key="index"
                             class="trades__item"
                             @click="getLoads(index)"
                             :class="{active: selectedTrade == index}">
                            <svg viewBox="-2 0 106 104" class="trades__icon">
                                <use v-bind="{ 'xlink:href': iconName(trade.name) + (selectedTrade == index ? '_active' : '') }"></use>
                            </svg>
                            <p class="paragraph paragraph--medium trades__name"><strong>{{trade.name}}</strong></p>
                        </div>
                    </slick>
                </div>
            </div>
            <div v-else>
                <h2 class="text-center">Sorry!</h2>
                <p class="paragraph text-center">There has been an error loading the tool, please try again later.</p>
            </div>

            <transition name="fade">
                <div class="loads" v-if="loads.length">
                    <h3 class="h3 text-center mb-5"><strong>What size load do you need to carry?</strong></h3>
                    <slick ref="slickLoads" class="slickLoads"
                           :options="slickLoadsOptions"
                           v-match-heights="{el: ['.loads__item']}"
                           @breakpoint="slickHandleBreakpoint">
                        <div class="loads__item" v-for="(load, index) in loads" :key="index"
                             @click="getVans(index)"
                             :class="{active: selectedLoad == index}">

                            <svg viewBox="-2 0 100 106" class="loads__icon">
                                <use v-bind="{ 'xlink:href': iconName(load.name) + (selectedLoad == index ? '_active' : '') }"></use>
                            </svg>
                            <p class="paragraph loads__name text-center"><strong>{{load.name}}</strong></p>
                            <p class="paragraph mb-1">For example:</p>
                            <ul class="loads__description">
                                <li v-for="(item, index) in (load.description.split('\n'))" :key="index">
                                    {{ item }}
                                </li>
                            </ul>
                        </div>
                    </slick>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import Slick from './CustomSlick';
    export default {
        name: 'TradeList',

        components: {
            Slick
        },

        data() {
            return {
                slickTradesOptions: {
                    slidesToShow: 5,
                    infinite: false,
                    dots: true,
                    arrows: true,
                    appendArrows: '.slickTrades + .paging',
                    appendDots: '.slickTrades + .paging',
                    draggable: false,
                    swipeToSlide: true,

                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 4
                            }
                        },

                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 2
                            }
                        }
                    ]
                },

                slickLoadsOptions: {
                    slidesToShow: 3,
                    infinite: false,
                    dots: true,
                    arrows: true,
                    appendArrows: '.slickLoads + .paging',
                    appendDots: '.slickLoads + .paging',
                    draggable: false,
                    swipeToSlide: true,

                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2
                            }
                        },

                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                },

                loads: [],
                selectedTrade: null,
                selectedLoad: null
            };
        },

        methods: {
            getLoads(index) {
                this.loads = this.trades[index].vehicle_loads;
                this.selectedTrade = index;
                this.$store.commit('trade', index);

                this.$gtag.logStep(
                    'Trade',
                    'Payload Vanaliser - ' + this.getSelectedTradeName()
                );
            },

            getVans(index) {
                this.$store.commit('vanList', []);
                this.$store.dispatch('loadVans', this.loads[index].id);
                this.selectedLoad = index;
                this.$store.commit('load', index);

                // need to clear  selected van
                this.$store.commit('van', null);

                this.$gtag.logStep(
                    'Load',
                    'Payload Vanaliser - ' + this.getSelectedTradeName() + ' - ' + this.getSelectedLoadName()
                );
            },

            iconName(name) {
                return '#' +name.replace(/[^a-z]+/gi, '_').toLowerCase();
            }
        },

        computed: {
            trades() {
                return this.$store.getters.getTrades;
            }
        },

        watch: {
            loads: function () {
                if (this.loads.length > 0) {
                    if (typeof this.$refs.slickLoads !== 'undefined') {
                        this.$nextTick(() => {
                            this.refreshSlick('slickLoads');
                        });
                    }
                }

                // Clear any selected sub options
                this.$store.commit('vanList', []);
                this.$store.commit('van', null);
                this.selectedLoad = null;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
    .trades
        margin-top 4rem

        ::v-deep .trades__item
            display block !important
            color $color-blue-petrol
            text-align center
            cursor pointer
            max-width 18rem
            margin 0 auto;
            padding-top 2px // seems to cure top of icon cut off on ipad

            &.active
                .trades__icon
                    transform: translateZ(0); // Force safari repaint

        ::v-deep .trades__icon
            display block
            width 10rem
            height 10rem
            margin 0 auto 1.5rem


        ::v-deep .trades__name
            text-transform uppercase

    .loads
        margin-top 6rem

        ::v-deep .loads__item
            display block !important
            width 100%
            margin 0 auto
            padding 2.5rem
            background $color-grey
            cursor pointer

            &.active
                background-color $color-light-cyan

                .loads__icon
                    transform: translateZ(0); // Force safari repaint

        ::v-deep .loads__icon
            display block
            width 100px
            height 100px
            margin 0 auto 1.5rem

        ::v-deep .loads__name
            text-transform uppercase
</style>
